import { To } from 'react-router-dom'
import { ComponentPropsWithoutRef } from 'react'
import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu"

export interface SubItem {
    label: string
    href: To
}

export interface NavigationSubItem {
    label: string
    href: string
    description?: string
}

export interface NavigationItem {
    title: string
    description?: string
    href: string
    subItems?: NavigationSubItem[]
}

export interface MobileNavigationProps {
    isOpen: boolean
    onClose: () => void
}

export interface NavigationSection {
    title: string;
    items: NavigationItem[];
}

export interface NavigationContent {
    title: string;
    description?: string;
    href: string;
}

export const navigationItems: NavigationSection[] = [
    
    {
        title: "Services",
        items: [
            {
                title: "Consultancy",
                description: "Business consulting services",
                href: "/services/consulting",
                subItems: [
                    { label: "Startup Consulting", href: "/services/consulting/startup" },
                    { label: "Design & Development", href: "/services/consulting/design" },
                    { label: "Process Frameworks", href: "/services/consulting/frameworks" },
                    { label: "Revenue Optimization", href: "/services/consulting/revenue" },
                    { label: "Operations Efficiency", href: "/services/consulting/operations" },
                    { label: "Progress Assessment", href: "/services/consulting/assessment" }
                ]
            },
            {
                title: "Financial Services",
                description: "Financial service offerings",
                href: "/services/financial",
                subItems: [
                    { label: "Institutional Banking", href: "/services/financial/banking" },
                    { label: "Life Insurance Banking", href: "/services/financial/insurance" },
                    { label: "Portfolio Management", href: "/services/financial/portfolio" },
                    { label: "Wealth Management", href: "/services/financial/wealth" },
                    { label: "RSU Trading", href: "/services/financial/rsu" },
                    { label: "Tech Employee Insurance", href: "/services/financial/tech-insurance" },
                    { label: "Equity Lending", href: "/services/financial/equity-lending" },
                    { label: "Real Estate Financing", href: "/services/financial/real-estate" },
                    { label: "Franchises: Energy Farms, Vertical Farms, and Greenhouses", href: "/services/financial/franchises" },
                    { label: "Distressed Real Estate", href: "/services/financial/distressed" }
                ]
            },
            {
                title: "Research",
                description: "Research services",
                href: "/services/research",
                subItems: [
                    { label: "Government Research", href: "/services/research/government" },
                    { label: "Academic Research", href: "/services/research/academic" },
                    { label: "Private Research", href: "/services/research/private" }
                ]
            }
        ]
    },
    {
        title: "Investment Division",
        items: [
            {
                title: "Digital Funds",
                description: "Digital investment products",
                href: "/investment/digital-funds",
                subItems: [
                    { label: "Exchange Traded Products", href: "/investment/digital-funds/etp" },
                    { label: "Pooled Farm Lands", href: "/investment/digital-funds/farmlands" },
                    { label: "Real Estate Investment Trusts", href: "/investment/digital-funds/reits" },
                    { label: "Private Credit Products", href: "/investment/digital-funds/credit" },
                    { label: "Opportunity Zone Funds", href: "/investment/digital-funds/opportunity-zones" },
                    { label: "Municipal & Corporate Bonds", href: "/investment/digital-funds/bonds" },
                    { label: "Infrastructure Debt", href: "/investment/digital-funds/infrastructure" },
                    { label: "Asymmetric Volatility ETFs", href: "/investment/digital-funds/volatility" },
                    { label: "Commodities ETFs", href: "/investment/digital-funds/commodities" },
                    { label: "Film & Media", href: "/investment/digital-funds/media" },
                    { label: "Smart Cities", href: "/investment/digital-funds/smart-cities" },
                    { label: "Alternative Assets", href: "/investment/digital-funds/alternatives" }
                ]
            },
            {
                title: "Strategies",
                description: "Investment strategies and approaches",
                href: "/investment/strategies",
                subItems: [
                    { label: "Venture Funds", href: "/investment/strategies/venture" },
                    { label: "Private Equity / LBOs", href: "/investment/strategies/pe" },
                    { label: "Quantitative Strategies", href: "/investment/strategies/quant" },
                    { label: "Systematic Active Equity", href: "/investment/strategies/systematic" },
                    { label: "Fundamental Active Equity", href: "/investment/strategies/fundamental" },
                    { label: "Fission & Fusion Energy", href: "/investment/strategies/energy" }
                ]
            },{
                title: "Financial Services",
                description: "Comprehensive financial services",
                href: "/investment/services",
                subItems: [
                    { label: "Institutional Banking", href: "/investment/services/banking" },
                    { label: "Life Insurance Banking", href: "/investment/services/insurance" },
                    { label: "Portfolio Management", href: "/investment/services/portfolio" },
                    { label: "Private Wealth Management", href: "/investment/services/wealth" },
                    { label: "RSU Trading", href: "/investment/services/rsu" },
                    { label: "Tech Employee Insurance", href: "/investment/services/tech-insurance" },
                    { label: "Equity Lending", href: "/investment/services/equity-lending" },
                    { label: "Real Estate Financing", href: "/investment/services/real-estate" },
                    { label: "Franchises: Energy Farms, Vertical Farms, and Greenhouses", href: "/services/financial/franchises" },
                    { label: "Distressed Real Estate", href: "/investment/services/distressed" }
                ]
            },
            {
                title: "Financial Instruments",
                description: "Trading and investment instruments",
                href: "/investment/instruments",
                subItems: [
                    { label: "Derivatives", href: "/investment/instruments/derivatives" },
                    { label: "Commodities Contracts", href: "/investment/instruments/commodities" }
                ]
            }
        ]
    },{
        title: "Software & Technology",
        items: [
            
            {
                title: "DarDen Apps",
                description: "DarDen App ecosystem",
                href: "/software/darden",
                subItems: [
                    { label: "The DarDen App", href: "/software/darden/app" },
                    { label: "Trato", href: "/software/darden/trato" },
                    { label: "Portal", href: "/software/darden/portal" },
                    { label: "Sambbi", href: "/software/darden/sambbi" },
                    { label: "Tienda", href: "/software/darden/tienda" },
                    { label: "MGT", href: "/software/darden/mgt" },
                    { label: "OnWheels", href: "/software/darden/onwheels" },
                    { label: "Troppa", href: "/software/darden/troppa" },
                    { label: "Deneflitz", href: "/software/darden/deneflitz" },
                    { label: "Mercanti", href: "/software/darden/mercanti" },
                    { label: "Ressi", href: "/software/darden/ressi" },
                    { label: "RoomAid", href: "/software/darden/roomaid" },
                    { label: "FlyTrap", href: "/software/darden/flytrap" },
                    { label: "Sprinkle", href: "/software/darden/sprinkle" }
                ]
            },
            {
                title: "Standalone Verticals",
                description: "Industry-specific software solutions",
                href: "/software/vertical",
                subItems: [
                    { label: "SSimpleAuth", href: "/software/vertical/ssimpleauth" },
                    { label: "Tinta", href: "/software/vertical/tinta" },
                    { label: "CheckaCV", href: "/software/vertical/checkacv" },
                    { label: "Lectu", href: "/software/vertical/lectu" },
                    { label: "Scavanger", href: "/software/vertical/scavanger" },
                    { label: "Sentium", href: "/software/vertical/sentium" },
                    { label: "Insurance & Benefits", href: "/software/vertical/insurance" },
                    { label: "Cleo Estate Planning", href: "/software/vertical/estate" },
                    { label: "Flota SMLFTRs", href: "/software/vertical/flota" },
                    { label: "Ovelto", href: "/software/vertical/ovelto" }
                ]
            },
            {
                title: "Institutional Solutions",
                description: "Software tools for wealth managers and financial institutions",
                href: "/software/institutional",
                subItems: [
                    { label: "Investment Software & Data Intelligence", href: "/software/institutional/sdi" },
                    { label: "Syphen IR", href: "/software/institutional/syphen" },
                    { label: "Creditosn", href: "/software/institutional/creditosn" },
                    { label: "ESG Solutions", href: "/software/institutional/esg" }
                ]
            },
            {
                title: "APIs & Embedables",
                description: "Integration solutions for businesses",
                href: "/software/api",
                subItems: [
                    { label: "Insurance API", href: "/software/api/insurance" },
                    { label: "Stable Coins API", href: "/software/api/stable-coins" }
                ]
            },
            {
                title: "Digital Funds",
                description: "Comprehensive digital investment products",
                href: "/software/digital-funds",
                subItems: [
                    { label: "Exchange Traded Products", href: "/software/digital-funds/etp" },
                    { label: "Pooled Farm Lands", href: "/software/digital-funds/farmlands" },
                    { label: "Real Estate Investment Trusts", href: "/software/digital-funds/reits" },
                    { label: "Private Credit Products", href: "/software/digital-funds/credit" },
                    { label: "Opportunity Zone Funds", href: "/software/digital-funds/opportunity-zones" },
                    { label: "Municipal & Corporate Bonds", href: "/software/digital-funds/bonds" },
                    { label: "Infrastructure Debt", href: "/software/digital-funds/infrastructure" },
                    { label: "Asymmetric Volatility ETFs", href: "/software/digital-funds/volatility" },
                    { label: "Commodities ETFs", href: "/software/digital-funds/commodities" },
                    { label: "Film & Media", href: "/software/digital-funds/media" },
                    { label: "Smart Cities", href: "/software/digital-funds/smart-cities" },
                    { label: "Alternative Assets", href: "/software/digital-funds/alternatives" }
                ]
            }
        ]
    },
    {
        title: "Insights",
        items: [
            {
                title: "Shared Insights",
                description: "Industry knowledge and research",
                href: "/insights/shared",
                subItems: [
                    { label: "Industry Reports", href: "/insights/shared/reports" },
                    { label: "Learning Resources", href: "/insights/shared/learning" },
                    { label: "Financial News", href: "/insights/shared/news" },
                    { label: "Research Papers", href: "/insights/shared/research" }
                ]
            },
            {
                title: "Blog",
                description: "Latest updates and announcements",
                href: "/insights/blog",
                subItems: [
                    { label: "Opinion", href: "/insights/blog/opinion" },
                    { label: "Partner Insights", href: "/insights/blog/partner" },
                    { label: "Investment Announcements", href: "/insights/blog/announcements" }
                ]
            }
        ]
    },
    {
        title: "Community",
        items: [
            {
                title: "Philanthropic Initiatives",
                description: "Community support programs",
                href: "/community",
                subItems: [
                    { label: "FUEL REALITY", href: "/community/fuel-reality" },
                    { label: "AlphaZillenial", href: "/community/alphazillenial" },
                    { label: "Crypto Credit Union", href: "/community/crypto-union" },
                    { label: "Freelancer Fund", href: "/community/freelancer-fund" }
                ]
            }
        ]
    }
]

export type NavigationMenuProps = ComponentPropsWithoutRef<typeof NavigationMenuPrimitive.Root>
export type NavigationMenuLinkProps = ComponentPropsWithoutRef<typeof NavigationMenuPrimitive.Link>